// React
import { useEffect, useState } from "react";
// Components
import { BasicButton } from "../../components/menu/common/CommonButton";
import Controller from "../../components/menu/common/Controller";
// Recoil
import { useSetRecoilState } from "recoil";
import { isAdminMode } from "../../atom/menu";
import PopupNotice from "./PopupNotice";

function IntroNoOrder() {
  // 브이디메뉴 인원선택 화면

  // Recoil State
  const setIsAdminPopup = useSetRecoilState(isAdminMode);
  // useState
  const [viewState, setViewState] = useState<number>(1);
  const [adult, setAdult] = useState<number>(1);
  const [child, setChild] = useState<number>(0);

  // Function
  const tripleClick = () => {
    // **기능정의**
    // 로고 3번 클릭 시, 관리자 페이지 이동 (1초안에 3번 클릭)
    setIsAdminPopup(true);
  };

  useEffect(() => {
    const logoEle = document.getElementById("triple");
    if (logoEle) {
      // let clicks = 0;
      // let timer,
      //   timeout = 1000;
      logoEle.addEventListener("click", function (e) {
        tripleClick();
        // clicks++;
        // timer = setTimeout(function () {
        //   if (clicks == 3 || clicks == 4) tripleClick();
        //   clicks = 0;
        // }, timeout);
      });
    }
  }, []);

  const nextStep = () => {
    if (adult < 1) {
      alert("인원을 입력해주세요");
    } else {
      setViewState(1);
    }
  };

  return (
    <div className='intro-wrap'>
      <div className='menu-header-wrap'>
        <img
          id='triple'
          className='logo-img'
          src={"/assets/images/menu/logo.png"}
          alt='vd company logo'
        />
      </div>

      <div className='flex col' style={{ height: "calc(100% -  80px)" }}>
        <div className='menu-intro-wrap'>
          <div className='TO-title-1 text-color-gray-3'>맞춤 세팅을 위해</div>
          <div
            className='TO-title-1 text-color-gray-3'
            style={{ marginTop: 12 }}
          >
            식사 인원을 정확하게 입력해주세요!
          </div>
          <div className='intro-controls'>
            <div
              className='flex row align-items-center w-auto'
              style={{ gap: 114, height: "fit-content" }}
            >
              <div
                className='TO-title-2 text-color-gray'
                style={{ minWidth: "fit-content" }}
              >
                성인
              </div>
              <Controller value={adult} setValue={setAdult} />
            </div>
            <div
              className='flex row align-items-center w-auto'
              style={{ gap: 114, height: "fit-content" }}
            >
              <div
                className='TO-title-2 text-color-gray'
                style={{ minWidth: "fit-content" }}
              >
                유아
              </div>
              <Controller value={child} setValue={setChild} />
            </div>
          </div>
        </div>
        <div className='menu-intro-button'>
          <BasicButton text='완료' action={nextStep} />
        </div>
      </div>
      {viewState === 1 && (
        <PopupNotice
          isView={viewState}
          setIsView={setViewState}
          person={{ adult, child }}
        />
      )}
    </div>
  );
}
export default IntroNoOrder;
